import { Link, useLocation} from "react-router-dom";
import { ArrowBackIcon } from "./Icons";
import React, { useState, useEffect, useRef } from 'react';
import Typed from 'typed.js';
import "./../AppMathMode.css";
import ProjectsTable from "./researchTable";
import { useMediaQuery } from 'react-responsive';
import {getPublications} from './updatables';

const ResearchMathMode = ({page}) => {
  const isSmallScreen = useMediaQuery({ maxWidth: 670 });

  const [published, setPublished] = React.useState([]);

  React.useEffect(() => {
    async function loadPublications() {
      const data = await getPublications();
      setPublished(data);
    }

    loadPublications();
  }, []);

    return <div class="body" style={{height: "auto", width: "100%", position: "relative", backgroundSize: "cover", backgroundPosition: "center", zIndex: 0, color: "black", display: "inline-block", justifyContent: "space-between", padding: "16px", margin: "0px"}}>
      Research Interests:
      <p class="body" style={{fontSize: "22px", color: "black"}}>I have research experience in spectral graph theory, topological data analysis, and real analysis. Currently, I spend my time thinking about:
        <ul class="list">
          <li>Sobolev extension domains and domain boundaries</li>
          <li>Lipschitz and Monotone extension theorems</li>
        </ul>
      </p>
      Papers & Preprints:
      <ol reversed>
        {published.reverse().map((item, index) => (
          <li
            key={index}
            style={{
              fontFamily: "Garamond, serif",
              fontSize: "22px",
              paddingBottom: "8px", color: "black"
            }}
          >
            <span style={{textDecoration: "underline", fontFamily: "Garamond, serif"}}>{item.title}</span>, {item.authors}, {item.publication.text}, <a href={item.publication.link} target="_blank" rel="noopener noreferrer" style={{fontFamily: "Garamond, serif", fontSize: "28px", textDecoration: "underline"}}>{item.publication.link}</a> ({item.year})
          </li>
        ))}
      </ol>
    </div>;
};

export default ResearchMathMode;